<template>
  <div
    class="page--product-detail"
    :class="{
      'sticky-button-write-review': !screen.isDesktop && !productExistsInSociolla,
    }"
  >
    <div class="container">
      <div v-if="screen.isDesktop">
        <ProductDetailLoader v-if="productDetailsLoading" />
        <div v-else-if="productDetails" class="content-page product-detail top">
          <div class="product-detail__left col-product">
            <div class="product-thumb">
              <img
                v-if="productDetails.product_images && productDetails.product_images.length"
                class="img-responsive img-block product-img"
                :src="mainImage(imageDetail.url)"
                onerror="this.src='/assets/img/dummy_product.svg'"
                :alt="`${productDetails.manufacture.name} ${productDetails.name} - Review SOCO by Sociolla`"
                @click="$store.commit('setModalImage', true)"
              />
              <img
                v-else
                class="img-responsive img-block product-img"
                src="/assets/img/dummy_product.svg"
                :alt="`${productDetails.manufacture.name} ${productDetails.name} - Review SOCO by Sociolla`"
              />
              <!-- <a
                v-if="!availableStock && productDetails.is_active_in_sociolla"
                class="btn btn-disabled product__button-sold-out"
                >OUT OF STOCK</a
              > -->
            </div>
            <div class="list-product-thumb">
              <carousel
                class="mt-16"
                :per-page-custom="[
                  [991, 4],
                  [992, 5],
                ]"
                :navigation-enabled="true"
                :per-page="5"
                navigation-next-label
                navigation-prev-label
                :pagination-enabled="false"
                :navigation-click-target-size="0"
              >
                <slide
                  v-for="(img, key) in productDetails.product_images"
                  :key="key"
                  :class="{ 'thumb-active': imageDetail['url'] === img['url'] }"
                >
                  <img
                    v-if="img.url"
                    :src="submainImage(img.url)"
                    width="58"
                    height="58"
                    class="img-responsive clickable product-small-img"
                    onerror="this.src='/assets/img/dummy_product.svg'"
                    alt="image-product"
                    @click="updateImageDetail(img)"
                  />
                  <img
                    v-else
                    src="/assets/img/dummy_product.svg"
                    width="58"
                    height="58"
                    class="img-responsive clickable product-small-img"
                    alt="image-product"
                    @click="updateImageDetail(img)"
                  />
                </slide>
              </carousel>
            </div>
            <div class="row">
              <div class="col-md-2">
                <span class="text-share">Share</span>
              </div>

              <div class="col-md-6">
                <ShareSosmedProduct
                  v-if="productDetails"
                  class="hidden-xs"
                  :product="productDetails"
                ></ShareSosmedProduct>
              </div>
            </div>
          </div>
          <div class="product-detail__right col-product-desc">
            <h2 v-if="productDetails.manufacture && productDetails.manufacture.name" class="brand-name">
              <router-link
                :to="`/brand/${productDetails.manufacture.my_soco_sql_id}/${$options.filters.slug(brandNameSlug)}`"
              >
                {{ productDetails.manufacture.name }}
              </router-link>
            </h2>
            <h1 v-if="productName" class="product-name">{{ productName }}</h1>

            <template v-if="!isFreebies">
              <div v-if="!productDetailsFromSociollaLoading">
                <h2 v-if="finalPrice && !activeCombination.enabled_in_freebies" class="product-price">
                  <span>{{ productPrice.final }}</span>
                  <span v-if="priceBeforeDiscount !== finalPrice" class="product-price__stroke">{{
                    productPrice.before
                  }}</span
                  ><span v-if="productPrice.discount" class="product__discount">[{{ productPrice.discount }}]</span>
                </h2>
              </div>
              <div v-else class="row">
                <div class="col-md-12">
                  <GFMP
                    key="loadingPriceDesktop1"
                    :styles="{
                      minHeight: '24px',
                      borderRadius: '10px',
                      width: '140px',
                      marginBottom: '23px',
                      display: 'block',
                      float: 'left',
                      marginRight: '5px',
                    }"
                  />
                  <GFMP
                    key="loadingPriceDesktop2"
                    :styles="{
                      minHeight: '24px',
                      borderRadius: '10px',
                      width: '100px',
                      marginBottom: '23px',
                      display: 'block',
                      float: 'left',
                    }"
                  />
                </div>
              </div>
            </template>

            <div v-if="isAvailableOfflineStore" class="offline-store">
              <SvgImg id="pin-store" name="pin-store" width="20" height="25" />
              <p>Available at Sociolla Store&nbsp;<span class="see-store" @click="seeStore">See Store</span></p>
            </div>

            <div
              :class="{
                'd-block': !isDesktop && (!productDetails.pack_detail || !productDetails.pack_detail.length),
              }"
              class="options"
            >
              <!-- Size -->
              <div
                v-if="
                  isDesktop &&
                  listSize.length &&
                  getGroupType(productDetails) &&
                  getGroupType(productDetails).indexOf('size') != -1
                "
                class="option-item"
              >
                <div class="option-full">
                  <div class="label-option">Size</div>
                  <div class="form-full">
                    <ul class="pick-con">
                      <li v-for="(item, i) in listSize" :key="i" class="pick-item">
                        <a
                          href=""
                          :title="item.name"
                          :class="[
                            attributeChaged &&
                            (couplesAttributes.size == item.id || couplesAttributes.non_specify == item.id) &&
                            !firstInit
                              ? 'selected'
                              : '',
                            item.active ? 'available' : 'not-available',
                          ]"
                          @click.prevent="setProductAttribute(item, 'size', '', 'second')"
                        >
                          {{ item.name }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <!-- Variant -->
              <div
                v-if="
                  isDesktop &&
                  listVariant.length &&
                  getGroupType(productDetails) &&
                  getGroupType(productDetails).indexOf('variant') != -1
                "
                class="option-item"
              >
                <div class="option-full">
                  <div class="label-option">Variant</div>
                  <div class="form-full">
                    <ul class="pick-con">
                      <template v-for="(item, idx) in listVariant">
                        <li v-if="item.is_active_in_review" :key="idx" class="pick-item">
                          <a
                            href=""
                            :title="item.name"
                            :class="[
                              attributeChaged &&
                              (couplesAttributes.variant == item.id || couplesAttributes.non_specify == item.id) &&
                              !firstInit
                                ? 'selected'
                                : '',
                              item.active ? 'available' : 'not-available',
                            ]"
                            @click.prevent="setProductAttribute(item, 'variant', '', 'second')"
                          >
                            {{ item.name }}
                          </a>
                        </li>
                      </template>
                    </ul>
                  </div>
                </div>
              </div>

              <!-- Shade -->
              <div
                v-if="
                  isDesktop &&
                  listShade.length &&
                  getGroupType(productDetails) &&
                  getGroupType(productDetails).indexOf('shade') != -1
                "
                class="option-item"
              >
                <div class="option-full shade-desktop">
                  <div class="label-option">Shade</div>
                  <div v-if="!firstInit" class="shade-name">
                    {{ getCombinationName('shade') }}
                  </div>
                </div>
                <div class="option-full">
                  <!-- <div class="label-option label-shade"></div> -->
                  <ul class="shade-item">
                    <template v-for="(item, key) in listShade">
                      <li
                        v-if="item"
                        :key="key"
                        :class="[
                          attributeChaged &&
                          (couplesAttributes.shade == item.id || couplesAttributes.non_specify == item.id) &&
                          !firstInit
                            ? 'selected'
                            : '',
                          item.active ? 'available' : 'not-available',
                        ]"
                      >
                        <a href="" :title="item.name" @click.prevent="setProductAttribute(item, 'shade', '', 'second')">
                          <template v-if="isImage(item.value) && item.value">
                            <button :class="{ 'block-shade': !item.active }">
                              <img :src="item.value" @error="imageErrorHandler($event)" />
                            </button>
                          </template>
                          <template v-else-if="!isImage(item.value) && item.value">
                            <button
                              :style="`background:${item.value}`"
                              :class="{ 'block-shade': !item.active }"
                            ></button>
                          </template>
                          <button v-else style="background: #ffffff" :class="{ 'block-shade': !item.active }"></button>
                        </a>
                      </li>
                    </template>
                  </ul>
                </div>
              </div>
            </div>
            <div class="review-users">
              <div class="review-users__rating">
                <h4 class="review-users__heading">Product Rating</h4>
                <div class="average-rating--uniform">
                  <div class="rating--uniform timeline-review">
                    <a href="#seeAllReview">
                      <div :class="`rate-star--uniform rate-star--uniform-${averageRating * 10} bigest-star`">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                      <span class="count">{{ averageRating ? averageRating : '0.0' }} </span>
                    </a>
                  </div>
                </div>
                <p class="text-recomended">
                  <template v-if="averageRating">
                    {{ $options.filters.cnvrtNumberToK(productDetails.review_stats.total_recommended_count) }}
                    of
                    {{ $options.filters.cnvrtNumberToK(productDetails.review_stats.total_reviews) }}
                    reviewers recommend this product.&nbsp;<a href="#seeAllReview" class="text-recomended__link"
                      >See all reviews</a
                    >
                    <div v-if="!screen.isDesktop" class="review-recommend-repurchase">
                      <div class="review-recommend">
                        <img src="/assets/img/thumb-pink.svg" alt="thumb" height="13.3" width="14" />
                        <p>
                          <span class="percentage">{{ Math.ceil((totalRecommend / totalReviews) * 100) }}%</span>
                          <span> users recommend</span>
                        </p>
                      </div>
                      <div class="review-repurchase">
                        <img src="/assets/img/repurchase-pink.svg" alt="wallet" height="14" width="14" />
                        <p>
                          <span class="percentage">{{ Math.ceil((totalRepurchase / totalReviews) * 100) }}%</span>
                          <span> users repurchase</span>
                        </p>
                      </div>
                    </div>
                  </template>
                  <template v-else> Belum ada review untuk produk ini </template>
                </p>
              </div>
              <div v-if="ratingTypes && ratingTypes.length" class="review-users__rating-detail">
                <h4 class="review-users__heading">Rating Detail</h4>
                <ul class="list-give-rating">
                  <li v-for="(ratingType, keyRating) in ratingTypes" :key="keyRating" class="list-give-rating__item">
                    <span class="list-give-rating__value"
                      ><span class="bolder">{{ ratingType.value.toFixed() }}</span
                      >/5</span
                    >{{ ratingType.name | generatedRatingTypeName }}
                  </li>
                </ul>
              </div>
              <div v-if="averageRating" class="review-users__repurchase">
                <h4 class="review-users__heading">Repurchase This Product ?</h4>
                <div class="review-recommend-repurchase">
                  <div class="review-recommend">
                    <img src="/assets/img/thumb-pink.svg" alt="thumb" height="13.3" width="14" />
                    <p>
                      <span class="percentage">{{ Math.ceil((totalRecommend / totalReviews) * 100) }}%</span>
                      <span> users recommend</span>
                    </p>
                  </div>
                  <div class="review-repurchase">
                    <img src="/assets/img/repurchase-pink.svg" alt="wallet" height="14" width="14" />
                    <p>
                      <span class="percentage">{{ Math.ceil((totalRepurchase / totalReviews) * 100) }}%</span>
                      <span> users repurchase</span>
                    </p>
                  </div>
                </div>
                <ul v-show="false">
                  <li class="item-repurchase color_yes">
                    <span class="rail">
                      <span class="top" :style="'width:' + repurchase(productDetails, 'yes') + '%;'"></span>
                      <span class="middle" :style="'width:' + repurchase(productDetails, 'no') + '%;'"></span>
                      <span class="end" :style="'width:' + repurchase(productDetails, 'maybe') + '%;'"></span>
                    </span>
                  </li>
                  <li>
                    <span class="purchase-title">
                      <span class="dot__yes"></span>
                      <b>Yes</b> ({{ getRatingObject(productDetails, 'total_repurchase_yes_count') | nFormatter }})
                    </span>
                    <span class="purchase-title">
                      <span class="dot__no"></span>
                      <b>No</b> ({{ getRatingObject(productDetails, 'total_repurchase_no_count') | nFormatter }})
                    </span>
                    <span class="purchase-title">
                      <span class="dot__maybe"></span>
                      <b>Maybe</b> ({{ getRatingObject(productDetails, 'total_repurchase_maybe_count') | nFormatter }})
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <template v-if="productDetails.review_stats.total_reviews">
              <section v-if="isReviewedByExpert" class="expert-reviews-v2">
                <header>
                  <img src="/assets/img/expert-review/expert-checked-white.svg" width="30" height="30" />
                  <h1>But First,<br />Read Expert Review</h1>
                </header>
                <p>
                  Yuk, baca dulu apa kata Expert tentang produk ini supaya kamu dapat rekomendasi yang tepat!
                  <a href="#seeAllReview"> Read here </a>
                </p>
              </section>
              <section v-else class="shopper-reviews-badge">
                <img src="/assets/img/expert-review/read-see-more-review-mobile.svg" />
                <p>
                  Baca dulu <b>Shopper Reviews</b> untuk bantu kamu memilih dengan tepat!
                  <a href="#seeAllReview"> Read here </a>
                </p>
              </section>
            </template>

            <UserPhotos key="UserPhotosDesktop" />

            <div class="btn-group-action">
              <template v-if="Object.keys(activeCombination).length > 0">
                <router-link
                  v-if="isLogin && checkAllCombinationReviewed()"
                  :to="`/review/add/${product_id}?origin=pdp`"
                  class="btn black disabled"
                  >Reviewed</router-link
                >
                <router-link
                  v-else-if="isLogin"
                  :to="`/review/add/${product_id}?origin=pdp`"
                  class="btn black"
                  @click.native="internalTrack('add', 'add_review')"
                  >Add review</router-link
                >
                <a v-else href="" class="btn black" @click.prevent="loginOtf('add', 'add_review')">Add review</a>
              </template>
              <template v-else>
                <router-link
                  v-if="isLogin && productDetails.is_reviewed && productDetails.is_reviewed_combination"
                  :to="`/review/add/${product_id}?origin=pdp`"
                  class="btn black disabled"
                  >Reviewed</router-link
                >
                <router-link
                  v-else-if="isLogin"
                  :to="`/review/add/${product_id}?origin=pdp`"
                  class="btn black"
                  @click.native="internalTrack('add', 'add_review')"
                  >Add review</router-link
                >
                <a v-else href="" class="btn black" @click.prevent="loginOtf('add', 'add_review')">Add review</a>
              </template>
              <a
                v-if="(productDetails.is_active_in_lulla || productDetails.is_active_in_sociolla) && !isFreebies"
                :href="productUrl(productDetails)"
                class="btn"
                target="_blank"
                rel="noopener"
                :class="{ disabled: !availableStock }"
                @click="internalTrack('click', 'shop_now')"
                >{{ copywritingButtonShop }}</a
              >
              <template v-if="productExistsInSociolla">
                <template v-if="isLogin">
                  <a v-if="isInWishlist" href="" class="product-add-wishlist active" @click.prevent="addWishList">
                    <img
                      src="/assets/img/icons/wishlist-icon-active.svg"
                      class="product-add-wishlist__icon"
                      alt="icon-wishlist"
                    />
                  </a>
                  <a v-else href="" class="product-add-wishlist" @click.prevent="addWishList">
                    <img
                      src="/assets/img/icons/wishlist-icon.svg"
                      class="product-add-wishlist__icon"
                      alt="icon-wishlist"
                    />
                  </a>
                </template>
                <template v-else>
                  <a href="" class="product-add-wishlist" @click.prevent="loginOtf">
                    <img
                      src="/assets/img/icons/wishlist-icon.svg"
                      class="product-add-wishlist__icon"
                      alt="icon-wishlist"
                    />
                  </a>
                </template>
              </template>
              <template v-else>
                <a
                  v-if="isLogin"
                  href=""
                  class="product-add-wishlist active"
                  :class="{ active: isInWishlist }"
                  @click.prevent="addWishList"
                >
                  <img v-if="isInWishlist" src="/assets/img/icons/wishlist-icon-active.svg" alt />
                  <img v-else src="/assets/img/icons/wishlist-icon.svg" alt />
                </a>
                <a v-else href="" class="product-add-wishlist" @click.prevent="loginOtf">
                  <img src="/assets/img/icons/wishlist-icon.svg" alt />
                </a>
              </template>
            </div>

            <div class="tabs--uniform">
              <ul class="list-tabs">
                <li :class="{ active: tabActive === 'products' }">
                  <a href="" @click.prevent="updateActiveTab('products')">
                    <span>Description</span>
                  </a>
                </li>
                <li v-if="howToUseDesc" :class="{ active: tabActive === 'howtouse' }">
                  <a href="" @click.prevent="updateActiveTab('howtouse')">
                    <span>How to use</span>
                  </a>
                </li>
                <li v-if="ingredientsDesc" :class="{ active: tabActive === 'ingredients' }">
                  <a href="" @click.prevent="updateActiveTab('ingredients')">
                    <span>Ingredients</span>
                  </a>
                </li>
              </ul>
            </div>

            <div class="tabs-content">
              <div v-show="tabActive === 'products'" class="tabs-content--descriptions">
                <div class="long-desc">
                  <!-- eslint-disable vue/no-v-html -->
                  <div
                    v-if="productDescription && productDescription.length > 700 && isMore"
                    v-html="getProductDescription"
                  ></div>
                  <div
                    v-else
                    v-html="productDescription ? productDescription : 'Tidak ada deskripsi pada produk ini'"
                  ></div>
                  <template v-if="productDescription && productDescription.length > 700">
                    <a v-if="isMore" href="" class="seemore" @click.prevent="toggleMore('isMore')">See more</a>
                    <a v-else href="" class="seemore rotate" @click.prevent="toggleMore('isMore')">See less </a>
                  </template>
                </div>
              </div>

              <div v-show="tabActive === 'howtouse' && howToUseDesc" class="tabs-content--descriptions">
                <div class="long-desc">
                  <div v-if="howToUseDesc && howToUseDesc.length > 700 && isMore" v-html="getHowToUseDesc"></div>
                  <div v-else v-html="howToUseDesc ? howToUseDesc : 'No content'"></div>
                  <template v-if="howToUseDesc && productDetails.how_to_use.length > 700">
                    <a v-if="isMore" href="" class="seemore" @click.prevent="toggleMore('isMore')">See more</a>
                    <a v-else href="" class="seemore rotate" @click.prevent="toggleMore('isMore')">See less </a>
                  </template>
                </div>
              </div>

              <div v-show="tabActive === 'ingredients' && ingredientsDesc" class="tabs-content--descriptions">
                <div class="long-desc">
                  <div
                    v-if="ingredientsDesc && ingredientsDesc.length > 700 && isMore"
                    v-html="getIngredientsDesc"
                  ></div>
                  <div v-else v-html="ingredientsDesc ? ingredientsDesc : 'No content'"></div>
                  <template v-if="ingredientsDesc && ingredientsDesc.length > 700">
                    <a v-if="isMore" href="" class="seemore" @click.prevent="toggleMore('isMore')">See more</a>
                    <a v-else href="" class="seemore rotate" @click.prevent="toggleMore('isMore')">See less </a>
                  </template>
                </div>
              </div>
            </div>
            <div class="brand-descriptions">
              <div class="brand-descriptions-header">
                <span> About The Brand </span>
                <router-link
                  :to="`/brand/${productDetails.manufacture.my_soco_sql_id}/${$options.filters.slug(brandNameSlug)}`"
                >
                  <span class="see-brand">View brand</span>
                </router-link>
              </div>
              <div class="brand-descriptions-wrapper">
                <div v-if="productDetails.brand.logo" class="brand-descriptions-image">
                  <img
                    :src="productDetails.brand.logo"
                    width="53"
                    height="53"
                    alt="Brand Logo"
                    onerror="this.src='/assets/img/default_img_brand.svg'"
                  />
                </div>
                <div class="brand-descriptions-info">
                  <h2 :class="{ middle: !brandDescription }" v-html="productDetails.brand.name"></h2>
                  <div v-if="brandDescription" class="content-list-wrap" v-html="getBrandDescription"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <ProductDetailMobileLoader v-if="productDetailsLoading" key="ProductDetailLoadingMobile" />
        <template v-else-if="productDetails">
          <div class="product-detail product-detail-mobile">
            <template v-if="productExistsInSociolla">
              <template v-if="isLogin">
                <a v-if="isInWishlist" href="" class="product-bookmark" @click.prevent="addWishList">
                  <img
                    src="/assets/img/icons/wishlist-icon-active.svg"
                    class="product-add-wishlist__icon"
                    alt="icon-wishlist"
                  />
                </a>
                <a v-else href="" class="product-bookmark" @click.prevent="addWishList">
                  <img
                    src="/assets/img/icons/wishlist-icon.svg"
                    class="product-add-wishlist__icon"
                    alt="icon-wishlist"
                  />
                </a>
              </template>
              <template v-else>
                <a href="" class="product-bookmark" @click.prevent="loginOtf">
                  <img
                    src="/assets/img/icons/wishlist-icon.svg"
                    class="product-add-wishlist__icon"
                    alt="icon-wishlist"
                  />
                </a>
              </template>
            </template>
            <template v-else>
              <a
                v-if="isLogin"
                href=""
                class="product-bookmark"
                :class="{ active: isInWishlist }"
                @click.prevent="addWishList"
              >
                <img
                  v-if="productDetails.has_bookmarked || isInWishlist"
                  src="/assets/img/icons/wishlist-icon-active.svg"
                  class="product-add-wishlist__icon"
                  alt
                />
                <img v-else src="/assets/img/icons/wishlist-icon.svg" class="product-add-wishlist__icon" alt />
              </a>
              <a v-else href="" class="product-bookmark" @click.prevent="loginOtf">
                <img src="/assets/img/icons/wishlist-icon.svg" class="product-add-wishlist__icon" alt />
              </a>
            </template>

            <div class="product-thumb">
              <img
                v-if="
                  shownImage ||
                  (productDetails.product_images &&
                    productDetails.product_images.length &&
                    productDetails.product_images[0].url !== 'nan')
                "
                class="img-responsive img-block product-img"
                :src="defaultImagesChanged ? defaultImagesChanged : mainImage(productDetails.product_images[0].url)"
                :alt="productDetails.manufacture.name"
                onerror="this.src='/assets/img/dummy_product.svg'"
                @click="$store.commit('setModalImage', true)"
              />
              <img
                v-else
                class="img-responsive img-block product-img"
                src="/assets/img/dummy_product.svg"
                :alt="productDetails.manufacture.name"
              />
              <!-- <a
                v-if="!availableStock && productDetails.is_active_in_sociolla"
                class="btn btn-disabled product__button-sold-out"
                >OUT OF STOCK</a
              > -->
            </div>
            <div class="product-info">
              <h2 v-if="productDetails.manufacture && productDetails.manufacture.name" class="brand-name">
                <router-link
                  :to="`/brand/${productDetails.manufacture.my_soco_sql_id}/${$options.filters.slug(brandNameSlug)}`"
                >
                  {{ productDetails.manufacture.name }}
                </router-link>
              </h2>
              <h1 v-if="productName" class="product-name">{{ productName }}</h1>
              <div v-if="getCombinationName('shade') !== 'Select Shade' && !firstInit" class="product-combination">
                {{ getCombinationName('shade') }}
              </div>
              <template v-if="!isFreebies">
                <div v-if="!productDetailsFromSociollaLoading">
                  <h2 v-if="productPrice.final" class="product-price">
                    <span class="product-price__text">{{ productPrice.final }}</span>
                  </h2>
                  <h2 class="product-price">
                    <span v-if="productPrice.before" class="product-price__stroke">{{ productPrice.before }}</span
                    ><span v-if="productPrice.discount" class="product__discount">[{{ productPrice.discount }}]</span>
                  </h2>
                </div>
                <div v-else class="row" style="margin-left: -15px; margin-right: -15px">
                  <div class="col-xs-10">
                    <GFMP
                      key="loadingPriceMobile1"
                      :styles="{
                        minHeight: '16px',
                        borderRadius: '10px',
                        width: '100%',
                        marginBottom: '23px',
                        display: 'block',
                        float: 'left',
                        marginRight: '5px',
                      }"
                    />
                  </div>
                </div>
              </template>
              <div class="product-rating">
                <div class="average-rating--uniform">
                  <div class="rating--uniform timeline-review">
                    <a href="#seeAllReview">
                      <div :class="`rate-star--uniform rate-star--uniform-${averageRating * 10} bigest-star`">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                      <span class="count">{{ averageRating ? averageRating : '0.0' }}</span>
                    </a>
                  </div>
                </div>
                <p v-if="averageRating" class="text-recomended">
                  ({{ $options.filters.cnvrtNumberToK(productDetails.review_stats.total_reviews) }} review{{
                    $options.filters.cnvrtNumberToK(productDetails.review_stats.total_reviews) > 1 ? 's' : ''
                  }})
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="
              (getGroupType(productDetails) &&
                (listSize.length || listVariant.length || listShade.length) &&
                (getGroupType(productDetails).indexOf('size') != -1 ||
                  getGroupType(productDetails).indexOf('variant') != -1)) ||
              getGroupType(productDetails).indexOf('shade') != -1 ||
              (attributeChaged &&
                activeCombination.is_active_in_offline_store &&
                activeCombination.stores &&
                activeCombination.stores.length &&
                !checkStoreActive(activeCombination.stores))
            "
            class="options mobile-shade-container"
          >
            <!-- Size -->
            <div
              v-if="
                listSize.length && getGroupType(productDetails) && getGroupType(productDetails).indexOf('size') != -1
              "
              class="option-item"
            >
              <div :class="['option-full', { shrink: !isCombinationToggleExpand.size }]">
                <div class="label-option">
                  <span>See other Size</span>
                  <img
                    src="/assets/img/chevron_down_red.svg"
                    height="5.5"
                    width="9.5"
                    class="toggle-icon"
                    @click="isCombinationToggleExpand.size = !isCombinationToggleExpand.size"
                  />
                </div>
                <div class="form-full">
                  <ul class="pick-con">
                    <li v-for="(item, idx) in listSize" :key="idx" class="pick-item">
                      <a
                        href=""
                        :title="item.name"
                        :class="[
                          attributeChaged &&
                          (couplesAttributes.size == item.id || couplesAttributes.non_specify == item.id) &&
                          !firstInit
                            ? 'selected'
                            : '',
                          item.active ? 'available' : 'not-available',
                        ]"
                        @click.prevent="setProductAttribute(item, 'size', '', 'second')"
                      >
                        {{ item.name }}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- Variant -->
            <div
              v-if="
                listVariant.length &&
                getGroupType(productDetails) &&
                getGroupType(productDetails).indexOf('variant') != -1
              "
              class="option-item"
            >
              <div :class="['option-full', { shrink: !isCombinationToggleExpand.variant }]">
                <div class="label-option">
                  <span>See other Variant</span>
                  <img
                    src="/assets/img/chevron_down_red.svg"
                    height="5.5"
                    width="9.5"
                    class="toggle-icon"
                    @click="isCombinationToggleExpand.variant = !isCombinationToggleExpand.variant"
                  />
                </div>
                <div class="form-full">
                  <ul class="pick-con">
                    <template v-for="(item, key) in listVariant">
                      <li v-if="item.is_active_in_review" :key="key" class="pick-item">
                        <a
                          href=""
                          :title="item.name"
                          :class="[
                            attributeChaged &&
                            (couplesAttributes.variant == item.id || couplesAttributes.non_specify == item.id) &&
                            !firstInit
                              ? 'selected'
                              : '',
                            item.active ? 'available' : 'not-available',
                          ]"
                          @click.prevent="setProductAttribute(item, 'variant', '', 'second')"
                        >
                          {{ item.name }}
                        </a>
                      </li>
                    </template>
                  </ul>
                </div>
              </div>
            </div>

            <!-- Shade -->
            <div
              v-if="
                listShade.length && getGroupType(productDetails) && getGroupType(productDetails).indexOf('shade') != -1
              "
              class="option-item"
            >
              <div :class="['option-full', { shrink: !isCombinationToggleExpand.shade }]">
                <div class="label-option">
                  <span>See other Shade</span>
                  <img
                    src="/assets/img/chevron_down_red.svg"
                    height="5.5"
                    width="9.5"
                    class="toggle-icon"
                    @click="isCombinationToggleExpand.shade = !isCombinationToggleExpand.shade"
                  />
                </div>
                <ul class="shade-item">
                  <li
                    v-for="(item, idx) in listShade"
                    :key="idx"
                    :class="[
                      attributeChaged &&
                      (couplesAttributes.shade == item.id || couplesAttributes.non_specify == item.id) &&
                      !firstInit
                        ? 'selected'
                        : '',
                      item.active ? 'available' : 'not-available',
                    ]"
                  >
                    <a href="" :title="item.name" @click.prevent="setProductAttribute(item, 'shade', '', 'second')">
                      <template v-if="isImage(item.value) && item.value">
                        <button :class="{ 'block-shade': !item.active }">
                          <img :src="item.value" @error="imageErrorHandler($event)" />
                        </button>
                      </template>
                      <template v-else-if="!isImage(item.value) && item.value">
                        <button :style="`background:${item.value}`" :class="{ 'block-shade': !item.active }"></button>
                      </template>
                      <button v-else style="background: #ffffff" :class="{ 'block-shade': !item.active }"></button>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div v-if="isAvailableOfflineStore" class="offline-store">
              <SvgImg id="pin-store" name="pin-store" width="14" height="18" />
              <p>Available at Sociolla Store&nbsp;<span class="see-store" @click="seeStore">See Store</span></p>
            </div>
            <template v-if="productDetails.review_stats.total_reviews">
              <section v-if="isReviewedByExpert" class="expert-reviews-v2">
                <header>
                  <img src="/assets/img/expert-review/expert-checked-white.svg" width="30" height="30" />
                  <h1>But First,<br />Read Expert Review</h1>
                </header>
                <p>
                  Yuk, baca dulu apa kata Expert tentang produk ini supaya kamu dapat rekomendasi yang tepat!
                  <a href="#seeAllReview"> Read here </a>
                </p>
              </section>
              <section v-else class="shopper-reviews-badge">
                <img src="/assets/img/expert-review/read-see-more-review-mobile.svg" />
                <p>
                  Baca dulu <b>Shopper Reviews</b> untuk bantu kamu memilih dengan tepat!
                  <a href="#seeAllReview"> Read here </a>
                </p>
              </section>
            </template>
          </div>

          <div class="tabs--uniform">
            <ul class="list-tabs">
              <li :class="{ active: tabActive === 'rating' }">
                <a href="" @click.prevent="updateActiveTab('rating')"> Rating </a>
              </li>
              <li :class="{ active: tabActive === 'products' }">
                <a href="" @click.prevent="updateActiveTab('products')">
                  <span>Description</span>
                </a>
              </li>
              <li v-if="howToUseDesc" :class="{ active: tabActive === 'howtouse' }">
                <a href="" @click.prevent="updateActiveTab('howtouse')">
                  <span>How to use</span>
                </a>
              </li>
              <li v-if="ingredientsDesc" :class="{ active: tabActive === 'ingredients' }">
                <a href="" @click.prevent="updateActiveTab('ingredients')">
                  <span>Ingredients</span>
                </a>
              </li>
            </ul>
          </div>

          <div class="tabs-content">
            <div v-show="tabActive === 'rating'" class="tabs-content--rating">
              <div class="review-users">
                <div :class="['review-users__rating-detail', { 'no-rating': !averageRating }]">
                  <ul v-if="averageRating" class="list-give-rating">
                    <li v-for="(ratingType, keyRating) in ratingTypes" :key="keyRating" class="list-give-rating__item">
                      <span class="list-give-rating__value"
                        ><span class="bolder">{{ ratingType.value.toFixed() }}</span
                        >/5</span
                      >
                      {{ ratingType.name | generatedRatingTypeName }}
                    </li>
                  </ul>
                  <template v-if="averageRating">
                    <div class="review-recommend-repurchase">
                      <div class="review-recommend">
                        <img src="/assets/img/thumb-pink.svg" alt="thumb" height="13.3" width="14" />
                        <p>
                          <span class="percentage">{{ Math.ceil((totalRecommend / totalReviews) * 100) }}%</span>
                          <span> Users Recommend</span>
                        </p>
                      </div>
                      <div class="review-repurchase">
                        <img src="/assets/img/repurchase-pink.svg" alt="wallet" height="14" width="14" />
                        <p>
                          <span class="percentage">{{ Math.ceil((totalRepurchase / totalReviews) * 100) }}%</span>
                          <span> Users Repurchase</span>
                        </p>
                      </div>
                    </div>
                    <div class="rate-badge">
                      <div class="average-rating--uniform">
                        <div class="rating--uniform timeline-review">
                          <div :class="`rate-star--uniform rate-star--uniform bigest-star`">
                            <span></span>
                          </div>
                        </div>
                      </div>
                      <span class="rate-badge__count">{{ averageRating ? averageRating : '0.0' }}</span>
                    </div>
                  </template>
                  <template v-else>
                    <div class="rate-badge rate-null">
                      <div class="average-rating--uniform">
                        <div class="rating--uniform timeline-review">
                          <div :class="`rate-star--uniform rate-star--uniform bigest-star`">
                            <span></span>
                          </div>
                        </div>
                      </div>
                      <span class="rate-badge__count">{{ averageRating ? averageRating : '0.0' }}</span>
                    </div>
                    <p class="text-recomended">Be the first to review this product</p>
                  </template>
                </div>
                <div class="review-users__repurchase">
                  <template v-if="averageRating"> </template>
                  <div v-else class="no-review">
                    <p>Habis belanja cantik di Sociolla? Yuk, bagikan pengalamanmu dan tulis review!</p>
                    <button v-if="isLogin" class="btn_white">
                      <router-link
                        :to="`/review/add/${product_id}?origin=pdp`"
                        @click.native="internalTrack('add', 'add_review')"
                      >
                        Add review
                      </router-link>
                    </button>
                    <button v-else class="btn_white" @click="loginOtf('add', 'add_review')">Add review</button>
                  </div>
                </div>
              </div>
            </div>

            <div v-show="tabActive === 'products'" class="tabs-content--descriptions">
              <div class="long-desc">
                <div
                  v-if="productDescription && productDescription.length > 700 && isMore"
                  v-html="getProductDescription"
                ></div>
                <div
                  v-else
                  v-html="productDescription ? productDescription : 'Tidak ada deskripsi pada produk ini'"
                ></div>
                <template v-if="productDescription && productDescription.length > 700">
                  <a v-if="isMore" href="" class="seemore" @click.prevent="toggleMore('isMore')">See more</a>
                  <a v-else href="" class="seemore rotate" @click.prevent="toggleMore('isMore')">See less </a>
                </template>
              </div>
              <div class="brand-descriptions">
                <div class="brand-descriptions-header">
                  <span> About The Brand </span>
                  <router-link
                    :to="`/brand/${productDetails.manufacture.my_soco_sql_id}/${$options.filters.slug(brandNameSlug)}`"
                  >
                    <span class="see-brand">View brand</span>
                  </router-link>
                </div>
                <div class="brand-descriptions-wrapper">
                  <div v-if="productDetails.brand.logo" class="brand-descriptions-image">
                    <img
                      :src="productDetails.brand.logo"
                      width="53"
                      height="53"
                      alt="Brand Logo"
                      onerror="this.src='/assets/img/default_img_brand.svg'"
                    />
                  </div>
                  <div class="brand-descriptions-info">
                    <h2 :class="{ middle: !brandDescription }" v-html="productDetails.brand.name"></h2>
                    <div v-if="brandDescription" class="content-list-wrap" v-html="getBrandDescription"></div>
                  </div>
                </div>
              </div>
            </div>

            <div v-show="tabActive === 'howtouse' && howToUseDesc" class="tabs-content--descriptions">
              <div class="long-desc">
                <div v-if="howToUseDesc && howToUseDesc.length > 700 && isMore" v-html="getHowToUseDesc"></div>
                <div v-else v-html="howToUseDesc ? howToUseDesc : 'No content'"></div>
                <template v-if="howToUseDesc && productDetails.how_to_use.length > 700">
                  <a v-if="isMore" href="" class="seemore" @click.prevent="toggleMore('isMore')">See more</a>
                  <a v-else href="" class="seemore rotate" @click.prevent="toggleMore('isMore')">See less </a>
                </template>
              </div>
            </div>

            <div v-show="tabActive === 'ingredients' && ingredientsDesc" class="tabs-content--descriptions">
              <div class="long-desc">
                <div v-if="ingredientsDesc && ingredientsDesc.length > 700 && isMore" v-html="getIngredientsDesc"></div>
                <div v-else v-html="ingredientsDesc ? ingredientsDesc : 'No content'"></div>
                <template v-if="ingredientsDesc && ingredientsDesc.length > 700">
                  <a v-if="isMore" href="" class="seemore" @click.prevent="toggleMore('isMore')">See more</a>
                  <a v-else href="" class="seemore rotate" @click.prevent="toggleMore('isMore')">See less </a>
                </template>
              </div>
            </div>
          </div>
          <div
            class="btn-group-action"
            :class="{
              'btn-group-action--fixed': !productExistsInSociolla || isSellableProduct,
              'btn-group-action--fixed-both': isSellableProduct && productExistsInSociolla,
            }"
          >
            <div class="row">
              <div class="col-xs-6">
                <template v-if="Object.keys(activeCombination).length > 0">
                  <router-link
                    v-if="isLogin && activeCombination.is_reviewed"
                    :to="`/review/add/${product_id}?origin=pdp`"
                    class="btn black disabled"
                    >Reviewed</router-link
                  >
                  <router-link
                    v-else-if="isLogin"
                    :to="`/review/add/${product_id}?origin=pdp`"
                    class="btn black"
                    @click.native="internalTrack('add', 'add_review')"
                    >Add review</router-link
                  >
                  <a v-else href="" class="btn black" @click.prevent="loginOtf('add', 'add_review')">Add review</a>
                </template>
                <template v-else>
                  <router-link
                    v-if="isLogin && productDetails.is_reviewed && productDetails.is_reviewed_combination"
                    :to="`/review/add/${product_id}?origin=pdp`"
                    class="btn black disabled"
                    >Reviewed</router-link
                  >
                  <router-link
                    v-else-if="isLogin"
                    :to="`/review/add/${product_id}?origin=pdp`"
                    class="btn black"
                    @click.native="internalTrack('add', 'add_review')"
                    >Add review</router-link
                  >
                  <a v-else href="" class="btn black" @click.prevent="loginOtf('add', 'add_review')">Add review</a>
                </template>
              </div>

              <div class="col-xs-6">
                <a
                  v-if="productDetails.is_active_in_lulla || productDetails.is_active_in_sociolla"
                  :href="productUrl(productDetails)"
                  class="btn"
                  target="_blank"
                  rel="noopener"
                  :class="{ disabled: !availableStock }"
                  @click="internalTrack('click', 'shop_now')"
                  >{{ copywritingButtonShop }}</a
                >
              </div>
            </div>
          </div>
        </template>
      </div>

      <!-- Most Relevant Reviews -->
      <Intersect
        v-if="screen.isDesktop && !productDetailsLoading && productDetails"
        @enter="enterSection('RelevantReviews')"
      >
        <div class="relevant-reviews--desktop">
          <template v-if="$SO.size(relevantReviews)">
            <section class="relevant-reviews--desktop__header">
              <template v-if="isLogin">
                <h4>Most Relevant Reviews</h4>
                <p>Review yang disesuaikan dengan beauty profile kamu.</p>
              </template>
              <h4 v-else>user reviews</h4>
            </section>
            <section class="relevant-reviews--desktop__reviews" :class="{ 'is-login': isLogin }">
              <carousel
                :navigation-enabled="true"
                :per-page="2"
                navigation-next-label
                navigation-prev-label
                pagination-enabled
                :navigation-click-target-size="0"
                :pagination-padding="4"
                class="relevant-review"
              >
                <slide v-for="(review, key) in relevantReviews" :key="`desktop${key}`">
                  <CardReviewDetailV2
                    :key="review._id"
                    :show-product="false"
                    :review-data="review"
                    :index="key + 1"
                    on="product"
                    is-relevant-review
                    is-expert-review
                    @set-like="onSetLike"
                  />
                </slide>
              </carousel>
              <div
                v-if="seeMoreRelevantReview.isOpen"
                class="see-more-popups"
                :class="{ left: seeMoreRelevantReview.index % 2 }"
              >
                <section class="see-more-popups__header">
                  <h4>Read More Review</h4>
                  <img
                    src="/assets/img/icon-close.svg"
                    alt="close"
                    height="22"
                    width="22"
                    @click.prevent="closeSeeMorePopup"
                  />
                </section>
                <section class="see-more-popups__content">
                  <p class="desc">{{ seeMoreRelevantReview.content }}</p>
                </section>
              </div>
            </section>
          </template>
        </div>
      </Intersect>

      <div v-if="!productDetailsLoading && productDetails">
        <Intersect @enter="enterSection('ReviewSection')">
          <div class="lazy-pixel">
            <div id="seeAllReview" class="row all-reviews-filtered">
              <div class="col-md-9 col-xs-12 col0">
                <template v-if="$SO.size(productDetails)">
                  <filteredReviews v-if="screen.isDesktop" :product="productDetails" :is_section="is_section" />
                  <template
                    v-else-if="
                      !screen.isDesktop && productDetails.review_stats && productDetails.review_stats.total_reviews > 0
                    "
                  >
                    <filtered-reviews-preview :product="productDetails" is-relevant-review></filtered-reviews-preview>
                  </template>
                </template>
              </div>
              <div v-if="screen.isDesktop" class="col-md-3 hidden-xs hidden-sm">
                <GSideAds key="GSideAds-ProductDetail" />

                <div v-if="$SO.size(relatedProducts)" class="related-product">
                  <h2 class="related-product__heading">Related Products</h2>

                  <GProduct
                    v-for="(product, key) in relatedProducts"
                    :key="key"
                    class="related-product-item"
                    class-modifier="product--inline"
                    :product="product"
                    :hide-total-reviews="false"
                    :hide-price="true"
                    :inline-reviewers="true"
                    :hide-combinations="true"
                    :is-related-product="true"
                  />
                </div>
                <div v-else class="popular-review">
                  <GFMP v-for="i in 2" :key="i" :styles="{ minHeight: '105px', marginBottom: '16px' }" />
                </div>
              </div>
            </div>
            <div
              v-if="!screen.isDesktop"
              class="products-mobile hidden-md hidden-lg"
              :class="{ 'mt-55': !$SO.size(relatedProducts) }"
            >
              <div v-if="$SO.size(relatedProducts)" class="section-related-product user-photos">
                <h4 class="section-heading">Related Products</h4>

                <ul class="list-user-photo">
                  <li v-for="(product, key) in relatedProducts" :key="`${key}-relatedProducts`">
                    <GProduct
                      :key="key"
                      :button-review="true"
                      :hide-total-reviews="false"
                      :hide-price="true"
                      :inline-reviewers="$options.filters.cnvrtNumberToK(product.review_stats.total_reviews)"
                      class="related-product-item-mobile"
                      :product="product"
                      :is-related-product="true"
                    />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </Intersect>
      </div>
    </div>

    <ModalUserPhotos v-if="isOpenModalUserPhotos" key="ModalUserPhotos" />
    <ModalStore v-if="isOpenModalStore" key="ModalStore" />
    <ModalImage
      v-if="isOpenModalImage"
      key="ModalImage"
      :products="productDetails"
      :current-combination="activeCombination"
      :current-image="defaultImagesChanged"
    />
    <ModalSeeMoreReviews
      v-if="isOpenModalSeeMoreReviews"
      key="ModalSeeMoreReviews"
      :product="productDetails"
    ></ModalSeeMoreReviews>
  </div>
</template>

<script>
const Config = require('~/config/default.env').default;
import { get } from 'lodash';
import jsonld from '@/shared/jsonld';
import Auth from '@/shared/auth';

export default {
  name: 'product-details',
  components: {
    ShareSosmedProduct: () => import('@/components/global/share-sosmed/share-sosmed-product'),
    filteredReviews: () => import('@/components/product/product-detail/filteredReviews'),
    filteredReviewsPreview: () => import('@/components/product/product-detail/filtered-reviews-preview'),
    ModalUserPhotos: () => import('@/components/product/product-detail/snippet/modal-user-photos'),
    UserPhotos: () => import('@/components/product/product-detail/snippet/user-photos'),
    ModalStore: () => import('@/components/product/product-detail/snippet/modal-store'),
    ModalImage: () => import('@/components/product/product-detail/snippet/modal-image'),
    ModalSeeMoreReviews: () => import('@/components/product/product-detail/snippet/modal-see-more-reviews'),
    CardReviewDetailV2: () => import('@/components/dashboard/snippet/card-review-detail-v2'),
    ProductDetailLoader: () => import('./product-detail-loader.vue'),
    ProductDetailMobileLoader: () => import('./product-detail-mobile-loader.vue'),
  },
  data() {
    return {
      shownImage: null,
      imageDetail: '',
      isOpenShareDropdown: false,
      productDetails: '',
      productDetailsFromSociolla: '',
      productDetailsLoading: false,
      productDetailsFromSociollaLoading: false,
      relatedProducts: null,
      userReviewImages: '',
      tabActive: 'products',
      ratingTypes: '',
      brandNameSlug: '',
      highestReview: '',
      isMore: true,
      activeCombination: {},
      attributeChaged: false,
      defaultImagesChanged: '',
      defaultPriceDiscountChanged: '',
      discountValue: '',
      listShade: [],
      listSize: [],
      listVariant: [],
      listCombination: [],
      couplesAttributes: {
        non_specify: '',
        size: '',
        variant: '',
        shade: '',
      },
      isFetchedDetails: false,
      section: {
        ReviewSection: false,
        RelevantReviews: false,
      },
      is_section: false,
      isCombinationToggleExpand: {
        size: true,
        shade: true,
        variant: true,
      },
      firstInit: false,
      fetchedDescription: '',
    };
  },
  computed: {
    availableStock() {
      return (
        this.productDetails.is_in_stock &&
        (!this.productDetails.is_out_of_stock_sociolla || !this.productDetails.is_out_of_stock_lilla)
      );
    },
    averageRating() {
      let result = 0;
      try {
        if (this.$SO.size(this.productDetails.review_stats) && this.productDetails.review_stats.average_rating) {
          result = this.$options.filters.productrating(this.productDetails.review_stats.average_rating);
        }
      } catch (error) {}
      return result;
    },
    copywritingButtonShop() {
      return this.availableStock ? 'Shop now' : 'Sold Out';
    },
    urlButtonShop() {
      if (this.productDetails.url_share) {
        return this.productDetails.url_share;
      } else {
        if (this.productDetailsFromSociolla) {
          return this.productDetailsFromSociolla.product_url_share;
        } else if (this.productDetails && this.productDetails.url_sociolla) {
          return this.productDetails.url_sociolla;
        } else {
          return window.location.href;
        }
      }
    },
    discount() {
      if (this.productDetails.discount_type === 'amount') {
        return `-Rp. ${this.$options.filters.currency(this.productDetails.discount)}`;
      } else if (this.productDetails.discount_type === 'percentage') {
        return `${this.productDetails.discount}%`;
      } else {
        return null;
      }
    },
    totalReviews() {
      return get(this.productDetails, 'review_stats.total_reviews', 0);
    },
    totalRecommend() {
      return get(this.productDetails, 'review_stats.total_recommended_count', 0);
    },
    totalRepurchase() {
      const yesRepurchase = get(this.productDetails, 'review_stats.total_repurchase_yes_count', 0);
      const maybeRepurchase = get(this.productDetails, 'review_stats.total_repurchase_maybe_count', 0);
      return yesRepurchase + maybeRepurchase;
    },
    finalPrice() {
      if (this.productDetails.la_ps_product_id_product && this.productDetails.active == 1) {
        if (this.showingRangePriceFromProductSociolla) {
          if (this.showingRangePriceFromProductSociollaForDiscount) {
            return `Rp ${this.$options.filters.currency(
              this.productDetailsFromSociolla.min_price_discount
            )} - Rp ${this.$options.filters.currency(this.productDetailsFromSociolla.max_price_discount)}`;
          } else {
            return `Rp ${this.$options.filters.currency(
              this.productDetails.min_price
            )} - Rp ${this.$options.filters.currency(this.productDetails.max_price)}`;
          }
        } else {
          if (
            this.productDetails.price_after_discount < this.productDetails.price &&
            this.productDetails.price_after_discount &&
            this.productDetails.discount_type
          ) {
            return `Rp ${this.$options.filters.currency(this.productDetails.price_after_discount)}`;
          } else {
            return `Rp ${this.$options.filters.currency(this.productDetails.price)}`;
          }
        }
      } else {
        return false;
      }
    },
    isLogin() {
      return Boolean(this.$SO.size(this.$store.state.auth.userProfile));
    },
    isOpenModalUserPhotos() {
      return this.$store.state.productDetail.isOpenModalUserPhotos;
    },
    isOpenModalStore() {
      return this.$store.state.productDetail.isOpenModalStore;
    },
    isOpenModalImage() {
      return this.$store.state.productDetail.isOpenModalImage;
    },
    isOpenModalSeeMoreReviews() {
      return this.$store.state.productDetail.isOpenModalSeeMoreReviews;
    },
    relevantReviews() {
      return this.$store.state.review.relevantReviews;
    },
    maxRepurchase() {
      if (this.$SO.size(this.productDetails)) {
        return Math.max(
          this.productDetails.review_stats.total_repurchase_yes_count,
          this.productDetails.review_stats.total_repurchase_no_count,
          this.productDetails.review_stats.total_repurchase_maybe_count
        );
      } else {
        return 0;
      }
    },
    page() {
      return this.$route.query.page;
    },
    priceBeforeDiscount() {
      if (this.showingRangePriceFromProductSociollaForDiscount) {
        if (this.$SO.size(this.productDetailsFromSociolla)) {
          return `Rp ${this.$options.filters.currency(
            this.productDetailsFromSociolla.min_price
          )} - Rp ${this.$options.filters.currency(this.productDetailsFromSociolla.max_price)}`;
        } else {
          return null;
        }
      } else {
        if (this.productDetails.discount_type && this.productDetails.price_after_discount < this.productDetails.price) {
          return `Rp ${this.$options.filters.currency(this.productDetails.price)}`;
        } else {
          return null;
        }
      }
    },
    productExistsInSociolla() {
      return this.productDetails.is_active_in_sociolla || this.productDetails.is_active_in_lulla;
    },
    isSellableProduct() {
      return this.productDetails.classification === 'sellable_products';
    },
    product_id() {
      const productId = this.$route.params.product_id.split('-');
      return Number(productId[0]);
    },
    screen() {
      return this.$store.state.screen;
    },
    showingRangePriceFromProductSoco() {
      return (
        Boolean(this.productDetails.min_price) &&
        Boolean(this.productDetails.max_price) &&
        this.productDetails.min_price !== this.productDetails.max_price
      );
    },
    showingRangePriceFromProductSociolla() {
      return (
        Boolean(this.productDetailsFromSociolla.min_price) &&
        Boolean(this.productDetailsFromSociolla.max_price) &&
        this.productDetailsFromSociolla.min_price !== this.productDetailsFromSociolla.max_price
      );
    },
    showingRangePriceFromProductSociollaForDiscount() {
      return (
        Boolean(this.productDetailsFromSociolla.min_price_discount) &&
        Boolean(this.productDetailsFromSociolla.max_price_discount) &&
        this.productDetailsFromSociolla.discount !== 0 &&
        this.productDetailsFromSociolla.min_price_discount !== this.productDetailsFromSociolla.max_price_discount
      );
    },
    isDesktop() {
      return this.$store.state.screen.isDesktop;
    },
    isSingleProduct() {
      let isSingleProduct = true;
      if (this.productDetails) {
        this.$SO.each(this.productDetails.combinations, (key, combination) => {
          this.$SO.each(combination.attributes, (attribute_name, value) => {
            if (attribute_name !== 'non_specify') {
              isSingleProduct = false;
            }
          });
        });
      }

      return isSingleProduct;
    },
    productName() {
      if (this.productDetails) {
        this.$store.commit('setPageInfo', {
          title: 'name' in this.productDetails ? this.productDetails.name : '',
          brand: 'name' in this.productDetails.brand ? this.productDetails.brand.name : '',
        });
        return 'name' in this.productDetails ? this.productDetails.name : '';
      }
      return '';
    },
    brandDescription() {
      if (this.productDetails) {
        return this.productDetails.brand.description || this.fetchedDescription;
      }
      return '';
    },
    productDescription() {
      if (this.productDetails) {
        return this.productDetails.description;
      }
      return '';
    },
    ingredientsDesc() {
      if (this.productDetails) {
        return this.productDetails.ingredients;
      }
      return '';
    },
    howToUseDesc() {
      if (this.productDetails) {
        return this.productDetails.how_to_use;
      }
      return '';
    },
    getBrandDescription() {
      const regexp = /<img[^>]+src\s*=\s*['"]([^'"]+)['"][^>]*>/g;
      const matchedImg = this.brandDescription.replace(regexp, '');
      if (matchedImg) {
        return this.$options.filters.trimBrandContent(matchedImg);
      } else {
        return this.$options.filters.trimBrandContent(this.brandDescription);
      }
    },
    getProductDescription() {
      return this.$options.filters.trimContent(this.productDescription);
    },
    getHowToUseDesc() {
      return this.$options.filters.trimContent(this.howToUseDesc);
    },
    getIngredientsDesc() {
      return this.$options.filters.trimContent(this.ingredientsDesc);
    },
    defaultPriceDiscount() {
      let result = 0;
      try {
        if (Object.keys(this.activeCombination).length) {
          this.getDiscountType(this.activeCombination);
          result = this.activeCombination.price_after_discount;
        } else {
          if (this.productDetails) {
            const the_product = this.productDetails;
            if (the_product.combinations && the_product.combinations.length) {
              const check = the_product.combinations.filter((value) => {
                result = value.default_on == 1;
              });
              if (check.length > 0) {
                this.getDiscountType(check[0]);
                result = check[0].price_after_discount;
              } else {
                if (the_product.combinations[0] && the_product.combinations[0].price_after_discount) {
                  this.getDiscountType(the_product.combinations[0]);
                  result = the_product.combinations[0].price_after_discount;
                } else {
                  this.getDiscountType(the_product);
                  result = the_product.price_after_discount;
                }
              }
            } else {
              this.getDiscountType(the_product);
              result = the_product.price_after_discount;
            }
          }
        }
      } catch (error) {}
      return result;
    },
    productPrice() {
      if (!this.productDetails || !Object.keys(this.productDetails).length) {
        return null;
      }
      let final = null;
      let before = null;
      let discount = null;
      let label = null;
      if (this.attributeChaged) {
        if (this.discountValue) {
          if (this.discountValue && this.isDiscountType && (this.defaultPrice || this.defaultPriceChanged)) {
            before =
              'Rp ' +
              (this.defaultPriceChanged
                ? this.$options.filters.currency(this.defaultPriceChanged)
                : this.$options.filters.currency(this.defaultPrice));
          }
          discount =
            this.isDiscountType === 'percentage'
              ? `-${this.discountValue}%`
              : `-Rp ${this.$options.filters.currency(this.discountValue)}`;
          label = this.isDiscountType === 'percentage' ? `${this.discountValue}%` : 'SALE';
        }
        if (this.defaultPriceDiscount || this.defaultPriceDiscountChanged) {
          const value = this.defaultPriceDiscountChanged
            ? this.$options.filters.currency(this.defaultPriceDiscountChanged)
            : this.$options.filters.currency(this.defaultPriceDiscount);
          final = isNaN(Number(value)) ? '' : 'Rp ' + value;
        } else {
          const value = this.defaultPriceChanged
            ? this.$options.filters.currency(this.defaultPriceChanged)
            : this.$options.filters.currency(this.defaultPrice);
          final = isNaN(Number(value)) ? '' : 'Rp ' + value;
        }
      } else {
        if (this.productDetails.discount_range) {
          final = this.productDetails.price_after_discount_range
            ? this.productDetails.price_after_discount_range
            : this.productDetails.price_range;
        } else {
          final = this.productDetails.price_range;
        }
        before = this.productDetails.discount_range
          ? this.productDetails.price_range
          : this.productDetails.price_after_discount_range;
        discount = this.productDetails.discount_range;
        label = null;
        if (discount) {
          label = this.productDetails.discount_percentage ? `${this.productDetails.discount_percentage}%` : 'SALE';
        }
      }
      return { final, before, discount, label };
    },
    isFreebies() {
      if (this.activeCombination && this.activeCombination.enabled_in_freebies) {
        return this.activeCombination.enabled_in_freebies;
      }
      return false;
    },
    isAvailableOfflineStore() {
      if (this.attributeChaged) {
        return (
          this.activeCombination.is_active_in_offline_store &&
          this.activeCombination.stores &&
          this.activeCombination.stores.length &&
          !this.checkStoreActive(this.activeCombination.stores)
        );
      } else {
        return this.listCombination.some(
          (data) =>
            data.is_active_in_offline_store && data.stores && data.stores.length && !this.checkStoreActive(data.stores)
        );
      }
    },
    isInWishlist() {
      return Object.keys(this.activeCombination).length && this.activeCombination.is_wishlist;
    },
    seeMoreRelevantReview() {
      return this.$store.state.review.seeMore;
    },
    isReviewedByExpert() {
      return this.productDetails.is_reviewed_by_expert;
    },
  },
  watch: {
    isLogin: {
      handler(newVal, oldVal) {
        if (newVal && !oldVal && this.isFetchedDetails) {
          this.getProductDetails();
          this.getRelevantReviews();
        }
      },
      immediate: true,
    },
    product_id(id) {
      if (id !== '' && !isNaN(id)) {
        this.$store.commit('setUserPhotos', []);
        this.getProductDetails();
      }
    },
    'screen.isDesktop'() {
      this.setTabActive();
    },
    productDetails(newProductDetails) {
      if (
        this.$SO.size(newProductDetails) &&
        newProductDetails.la_ps_product_id_product &&
        !this.productDetailsFromSociolla
      ) {
        this.getProductDetailsFromSociolla();
      }
      // if (this.$SO.size(newProductDetails) && this.showingRangePriceFromProductSoco) {
      const data = JSON.parse(JSON.stringify(newProductDetails));
      data.image_cover = '/assets/img/dummy_product.svg';
      data.average_rating = 0;
      data.total_reviews = 0;
      if (
        this.shownImage ||
        (newProductDetails.product_images &&
          newProductDetails.product_images.length &&
          newProductDetails.product_images[0].url !== 'nan')
      ) {
        data.image_cover = this.defaultImagesChanged
          ? this.defaultImagesChanged
          : this.mainImage(newProductDetails.product_images[0].url);
      }
      if (this.$SO.size(newProductDetails.review_stats) && newProductDetails.review_stats.average_rating) {
        data.average_rating = this.$options.filters.productrating(newProductDetails.review_stats.average_rating);
        if (newProductDetails.review_stats.total_reviews) {
          data.total_reviews = this.$options.filters.cnvrtNumberToK(newProductDetails.review_stats.total_reviews);
        }
      }
      // console.log(data.average_rating)
      this.$store.commit('setProductData', data);
      if (this.productDetails && this.productDetails.combinations && this.productDetails.combinations.length > 0) {
        this.setAllAttribute(this.productDetails.combinations[0]);
      }
    },
    'section.ReviewSection'(newVal) {
      if (newVal) {
        this.is_section = true;
        this.getHighestReview();
        this.getRelatedProducts();
      }
    },
    'section.RelevantReviews'(newVal) {
      if (newVal) {
        this.getRelevantReviews();
      }
    },
    $route({ params: { product_id: productIdTo } }, { params: { product_id: productIdFrom } }) {
      if (productIdTo && productIdFrom && productIdTo !== productIdFrom) {
        for (const key of Object.keys(this.section)) {
          this.section[key] = false;
        }
        this.is_section = false;
      }
    },
  },
  created() {
    this.getProductDetails();
    this.setTabActive();
    // this.getHighestReview();
  },
  beforeDestroy() {
    this.$store.commit('setUserPhotos', []);
    jsonld.remove();
  },
  methods: {
    imageErrorHandler(e) {
      e.target.src = '/assets/img/dummy-combination.png';
    },
    enterSection(field) {
      this.section[field] = true;
    },
    internalTrack(verb, object_type) {
      try {
        this.$store.dispatch('$_InternalTracking/track', {
          verb,
          object_id: this.productDetails.id,
          object_type,
          referrer: {
            id: this.productDetails.id,
            object_type: 'product_detail',
          },
          target: {
            id: this.productDetails.id,
            object_type: 'product_detail',
          },
        });
      } catch (err) {
        console.error(err);
      }
    },
    addJsonLd() {
      const trimmedDesc = this.productDetails.description
        ? this.$options.filters.trimContentDesc(this.productDetails.description)
        : '';
      const jsonldObject = {
        '@context': 'http://schema.org/',
        '@type': 'Product',
        name: this.productName,
        image: [this.imageDetail.url],
        description: this.productDetails.description ? this.$options.filters.stripHTML(trimmedDesc) : '',
        brand: {
          '@type': 'Brand',
          name: this.productDetails.brand.name ? this.productDetails.brand.name : '',
        },
      };

      const offers = {
        priceCurrency: 'IDR',
        itemCondition: 'NewCondition',
        availability: this.productDetails.is_in_stock ? 'InStock' : 'OutOfStock',
        seller: {
          '@type': 'Organization',
          name: 'Sociolla',
        },
        url: this.urlButtonShop,
      };

      if (this.productDetails.price_range) {
        if (
          this.productDetails.min_price_after_discount &&
          this.productDetails.max_price_after_discount &&
          this.productDetails.min_price_after_discount != this.productDetails.max_price_after_discount
        ) {
          offers['@type'] = 'AggregateOffer';
          offers.lowPrice = this.productDetails.min_price_after_discount;
          offers.highPrice = this.productDetails.max_price_after_discount;
          if (this.$SO.size(this.productDetails.combinations)) {
            offers.offerCount = this.$SO.size(this.productDetails.combinations);
          }
        } else {
          if (this.productDetails.max_price_after_discount) {
            offers['@type'] = 'Offer';
            offers.price = this.productDetails.max_price_after_discount;
          } else {
            if (
              this.productDetails.default_combination &&
              (this.productDetails.default_combination.price_after_discount ||
                this.productDetails.default_combination.price)
            ) {
              if (this.productDetails.default_combination.price_after_discount) {
                offers['@type'] = 'Offer';
                offers.price = this.productDetails.default_combination.price_after_discount;
              } else {
                offers['@type'] = 'Offer';
                offers.price = this.productDetails.default_combination.price;
              }
            } else {
              const get_price = this.productDetails.combinations.find((value) => value.is_default);
              if (get_price && Object.keys(get_price).length) {
                offers['@type'] = 'Offer';
                offers.price = get_price.price;
              }
            }
          }
        }
      }

      if (this.productDetails.price_range && this.productDetails.available_for_order) {
        jsonldObject.offers = offers;
      }

      if ('sku' in this.productDetails && this.productDetails.sku) {
        jsonldObject.sku = this.productDetails.sku;
      }
      if (this.productDetails.ean) {
        jsonldObject.gtin13 = this.productDetails.ean;
      }

      if (this.productDetails.review_stats.total_reviews > 0) {
        jsonldObject.aggregateRating = {
          '@type': 'AggregateRating',
          ratingValue: Number(this.averageRating),
          reviewCount: this.productDetails.review_stats.total_reviews,
        };
      } else {
        jsonldObject.aggregateRating = {
          '@type': 'AggregateRating',
          ratingValue: 0,
          reviewCount: 0,
        };
      }
      jsonld.setData(jsonldObject);
      jsonld.append(jsonld.data);
    },
    addWishList() {
      if (!this.productDetails.id) {
        this.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
        return null;
      } else {
        const combinationIndex = this.productDetails.combinations.findIndex(
          (row) => row._id === this.activeCombination._id
        );
        const currentWishlistStatus = this.productDetails.combinations[combinationIndex].is_wishlist;

        this.$MS_CATALOG_API_URL
          .post('/v3/users/me/wishlists', {
            product_id: Number(this.productDetails.id),
            product_combination_id: this.activeCombination._id,
          })
          .then((res) => {
            if (res.status == 200 && res.data.data) {
              this.$toasted.global.show(
                res.data.data.is_wishlisted ? 'Sukses menambahkan ke Wishlist.' : 'Wishlist berhasil dihapus.'
              );
              this.productDetails.combinations[combinationIndex].is_wishlist = res.data.data.is_wishlisted;
            } else {
              this.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
              this.productDetails.combinations[combinationIndex].is_wishlist = currentWishlistStatus;
            }
          })
          .catch((error) => {
            this.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
            this.productDetails.combinations[combinationIndex].is_wishlist = currentWishlistStatus;
          });
      }
    },
    bookmarkProduct() {
      this.productDetails.has_bookmarked = !this.productDetails.has_bookmarked;
      this.productDetails.has_bookmarked === true
        ? this.$toasted.global.show('Produk telah berhasil disimpan')
        : this.$toasted.global.show('Produk telah dihapus');
      this.$MS_SOCO_PUBLIC_API_URL
        .post(`/product/${this.product_id}/bookmarks`)
        .then((res) => {
          if (res.status !== 200) {
            this.productDetails.has_bookmarked = !this.productDetails.has_bookmarked;
          }
        })
        .catch((err) => {
          this.productDetails.has_bookmarked = !this.productDetails.has_bookmarked;
        });
    },
    getRelatedProducts() {
      if (!(this.productDetails && this.productDetails.default_category && this.productDetails.default_category.id)) {
        return;
      }
      this.$MS_SOCO_PUBLIC_API_URL
        .get(`/products`, {
          params: {
            filter: {
              $or: [{ is_active_in_sociolla: true }, { is_active_in_review: true }],
              'categories.id': `${this.productDetails.default_category.id}`,
              _id: { $nin: [`${this.productDetails._id}`] },
              brand: { $ne: null },
            },
            fields:
              'id brand name review_stats combinations images default_category parent_category my_sociolla_sql_id slug default_combination',
          },
        })
        .then((response) => {
          if (response.status == 200) {
            this.relatedProducts = response.data.data;
          } else {
            this.relatedProducts = [];
          }
        })
        .catch((err) => {
          this.relatedProducts = [];
          console.error(err);
        });
    },
    getHighestReview() {
      this.$MS_SOCO_PUBLIC_API_URL(`/reviews`, {
        params: {
          filter: {
            $and: [
              {
                product_id: this.productDetails.id,
              },
              {
                average_rating: { $gte: 5, $lt: 5.999 },
              },
            ],
          },
          limit: 1,
          skip: 0,
        },
      })
        .then((response) => {
          if (response.status === 200) {
            this.$store.commit('setMetaHighestReview', response.data.data[0]);
          } else {
            this.$store.commit('setMetaHighestReview', []);
          }
        })
        .catch((err) => {
          this.$store.commit('setMetaHighestReview', []);
        });
    },
    async getRelevantReviews() {
      return new Promise((resolve, reject) => {
        try {
          resolve(
            this.$MS_SOCO_PUBLIC_API_URL.get('/reviews', {
              params: {
                filter: {
                  is_published: true,
                  elastic_search: true,
                  product_id: this.product_id,
                  is_highlight: true,
                },
                skip: 0,
                limit: 6,
                sort: this.isLogin ? 'most_relevant' : '-total_likes',
              },
            })
          );
        } catch (error) {
          reject(error);
        }
      }).then((response) => {
        const reviews = get(response, 'data.data', []);
        const reviewFiltered = reviews.filter((item) => !item.is_spam);
        this.$store.commit('review/SET_RELEVANT_REVIEWS', reviewFiltered);
      });
    },
    getProductDetailsFromSociolla() {
      this.productDetailsFromSociollaLoading = true;
      if (this.productDetails.la_ps_product_id_product && this.productDetails.active == 1) {
        this.$MS_SOCO_PUBLIC_API_URL
          .get(`/products/sociolla/${this.productDetails.la_ps_product_id_product}`)
          .then((response) => {
            if (response.status == 200) {
              this.productDetailsFromSociolla = response.data.data;
              this.productDetailsFromSociollaLoading = false;
              this.addJsonLd();
            } else {
              this.productDetailsFromSociolla = {};
              this.productDetailsFromSociollaLoading = false;
            }
          })
          .catch((err) => {
            // console.log(err)
            this.productDetailsFromSociolla = {};
            this.productDetailsFromSociollaLoading = false;
          });
      } else {
        this.productDetailsFromSociollaLoading = false;
      }
    },
    getProductDetails() {
      this.productDetailsLoading = true;
      document.documentElement.classList.add('noscroll');
      document.body.classList.add('no-scroll');
      this.$MS_SOCO_PUBLIC_API_URL
        .get(`/products/${this.product_id}`, {
          params: {
            filter: {
              $and: [
                {
                  $or: [{ deleted_at: null }, { deleted_at: { $exists: false } }],
                },
                {
                  classification: {
                    $nin: ['egift', 'bundle_virtual'],
                  },
                },
              ],
              name: { $ne: null },
              is_active_in_review: true,
              // is_purchased_product: true,
            },
          },
        })
        .then((res) => {
          if (res.data.success && res.status == 200) {
            const data = res.data.data;
            const createdRatingTypes = [];

            this.$SO.each(data.review_stats.average_rating_by_types, (type, value) => {
              createdRatingTypes.push({
                name: type,
                value: value,
              });
            });

            if (data.is_active_in_review === false || this.$SO.size(data.brand) === 0) {
              this.$router.push('/404-page.html');
              return;
            }

            this.ratingTypes = createdRatingTypes;
            this.productDetails = data;
            this.productDetailsLoading = false;
            this.imageDetail =
              this.productDetails.product_images.find((e) => e.is_cover) || this.productDetails.product_images[0];
            this.branchNameSlug(data.manufacture.name);

            this.getListOptions(
              data.hasOwnProperty('combinations')
                ? data.combinations
                : [{ ...data.default_combination, images: data.images }]
            );

            if (data.combinations.length === 1) {
              this.setAllAttribute(data.default_combination, data);
              this.attributeChaged = true;
            }

            try {
              // this.$store.commit('setHeaderMeta', this.productDetails.slice(0))
              this.$store.commit('setHeaderMeta', this.productDetails);
              this.addJsonLd();
            } catch (err) {}
            // this.getRelatedProducts();
            this.getUserReviewImages();
            this.getUserReviewImagesCount();
            this.fetchBrand();
            this.track();
            this.isFetchedDetails = true;
            document.documentElement.classList.remove('noscroll');
            document.body.classList.remove('no-scroll');
            this.firstInit = true;
          }
        })
        .catch((err) => {
          console.error(err);
          document.documentElement.classList.remove('noscroll');
          document.body.classList.remove('no-scroll');
          this.productDetailsLoading = false;
          if (!this.$SO.size(this)) {
            return this.$router.push({ path: `/${this.$route.path}`, name: 'NotFound' });
          }
        });
    },
    getUserReviewImages() {
      this.$store
        .dispatch('getUserReviewImages', {
          params: {
            limit: 9,
          },
          product_id: this.product_id,
        })
        .then((response) => {
          if (response.status === 200) {
            this.$SO.each(response.data.data, (key, image) => {
              response.data.data[key].isLoadImageProcess = false;
            });
            this.$store.commit('setUserPhotos', response.data.data);
          } else {
            this.$store.commit('setUserPhotos', []);
          }
        })
        .catch((err) => {
          // console.log(err)
          this.$store.commit('setUserPhotos', []);
        });
    },
    getUserReviewImagesCount() {
      this.$MS_REVIEW_API_URL
        .get(`/review-images/${this.product_id}/product/count`)
        .then((response) => {
          if (response.status === 200) {
            this.$store.commit('setTotalUserPhoto', response.data.data);
          } else {
            this.$store.commit('setTotalUserPhoto', 0);
          }
        })
        .catch((err) => {
          // console.log(err)
          this.$store.commit('setTotalUserPhoto', 0);
        });
    },
    loginOtf(verb, object_type) {
      this.internalTrack(verb, object_type);
      Auth.CentralAuth.login();
    },
    repurchase(item, status) {
      if (item && item.review_stats) {
        const yes = Math.floor((item.review_stats.total_repurchase_yes_count * 100) / item.review_stats.total_reviews);
        const no = Math.floor((item.review_stats.total_repurchase_no_count * 100) / item.review_stats.total_reviews);
        if (status == 'yes') {
          return yes;
        }
        if (status == 'no') {
          return no;
        }
        if (status == 'maybe') {
          return 100 - yes - no;
        }
      }
    },
    getRatingObject(review, type) {
      let result = 0;
      if (review && review.review_stats) {
        if (review.review_stats[type]) {
          result = review.review_stats[type];
        }
      }
      return result;
    },
    setProgressBarRepurchase(repurchaseValue) {
      const total = this.maxRepurchase * 1.8;
      const percent = (repurchaseValue / total) * 100;
      return percent + '%';
    },
    setTabActive() {
      if (this.screen.isDesktop) {
        this.tabActive = 'products';
      } else {
        this.tabActive = 'rating';
      }
    },
    toggleShare(newVal) {
      if (newVal) {
        this.isOpenShareDropdown = !newVal;
      } else {
        this.isOpenShareDropdown = !this.isOpenShareDropdown;
      }
    },
    updateActiveTab(tabName) {
      this.tabActive = tabName;
    },
    updateImageDetail(newImage) {
      this.imageDetail = newImage;
    },
    branchNameSlug(name) {
      this.brandNameSlug = name.replace(' ', '-').toLowerCase();
    },
    mainImage(src) {
      return this.$options.filters.imageCdn({
        config: this.isDesktop ? 'w=360' : 'w=100',
        image: src,
      });
    },
    submainImage(src) {
      return this.$options.filters.imageCdn({
        config: 'w=58',
        image: src,
      });
    },
    productUrl(product) {
      let productLink = this.$options.filters.productLinkV3(product);
      if (product.default_combination && product.default_combination.attributes) {
        const { attributes } = product.default_combination;
        const keys = Object.keys(attributes || {});
        if (keys.length && keys[0] && attributes[keys[0]] && attributes[keys[0]]['name']) {
          productLink += '?';
          keys.forEach(
            (key, idx) =>
              (productLink += `${key}=${this.$options.filters.slug(attributes[key]['name'], '_')}${
                idx < keys.length - 1 ? '&' : ''
              }`)
          );
        }
      }
      return productLink;
    },
    fetchBrand() {
      axios
        .get(`${Config.MS_SOCO_PUBLIC_API_URL}/brands`, {
          params: {
            filter: {
              my_soco_sql_id: this.productDetails.brand.my_soco_sql_id,
            },
            skip: 0,
            limit: 5,
          },
        })
        .then((response) => {
          this.fetchedDescription = response.data.data[0].description;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    track() {
      const product = this.productDetails;
      const defaultCombination = product.default_combination;

      try {
        const productTrack = [
          {
            id: product.id,
            name: product.name,
            categoryid:
              'default_category' in product && 'id' in product.default_category ? product.default_category.id : '',
            category:
              'default_category' in product && 'name' in product.default_category ? product.default_category.name : '',
            variant: defaultCombination != undefined ? this.$options.filters.combinationName(defaultCombination) : '',
            price: defaultCombination != undefined ? defaultCombination.price_after_discount : '',
            brand: product.brand.name,
            Category_Parent: product.categories[0] ? product.categories[0].name : '',
            Category_Child: product.categories[1] ? product.categories[1].name : '',
            Category_GrandChild: product.categories[2] ? product.categories[2].name : '',
            stock: product.stock,
            preorder:
              Object.keys(product.default_combination).indexOf('is_pre_order') > -1
                ? product.default_combination.is_pre_order
                : false,
          },
        ];

        window.dataLayer.push({
          ecommerce: {
            detail: {
              actionField: { list: 'Product Detail Page' },
              products: productTrack,
            },
          },
        });

        window.dataLayer.push({
          ecommerce: {
            currencyCode: 'IDR',
            impressions: productTrack,
          },
        });

        window.dataLayer.push({
          event: 'productReady',
          page_name: product.id,
        });
      } catch (err) {
        console.error(err);
      }
    },
    toggleMore(key) {
      this[key] = !this[key];
    },
    isImage(value) {
      if (value && value.search('#') !== -1 && value.length <= 7) {
        return false;
      } else {
        return true;
      }
    },
    getCombinationName(type) {
      const type_name = type.toLowerCase().replace(/(?:^|\s)\S/g, function (a) {
        return a.toUpperCase();
      });
      let result = `Select ${type_name}`;
      if (this.attributeChaged && this.couplesAttributes && this.couplesAttributes[type]) {
        const get_combination_data = this[`list${type_name}`].find((attr) => attr.id == this.couplesAttributes[type]);
        if (get_combination_data) {
          result = get_combination_data.name;
        }
      }
      return result;
    },
    processDuplicate() {
      if (this.listSize) {
        const end = this.listSize.reduce((unique, o) => {
          if (!unique.some((obj) => obj.id === o.id)) {
            unique.push(o);
          }
          return unique;
        }, []);

        this.listSize = end;
      }

      if (this.listVariant) {
        const end = this.listVariant.reduce((unique, o) => {
          if (!unique.some((obj) => obj.id === o.id)) {
            unique.push(o);
          }
          return unique;
        }, []);

        this.listVariant = end;
      }

      if (this.listShade) {
        const end = this.listShade.reduce((unique, o) => {
          if (!unique.some((obj) => obj.id === o.id)) {
            unique.push(o);
          }
          return unique;
        }, []);

        this.listShade = end;
      }
    },
    getListOptions(item) {
      try {
        this.listShade = [];
        this.listSize = [];
        this.listVariant = [];
        this.listCombination = item;
        for (let i = 0; i < item.length; i++) {
          let readyStock = !item[i].is_out_of_stock_sociolla && item[i].stock > 0;
          if (item[i].is_pre_order) {
            readyStock = Boolean(item[i].preorder[0].total_quota > item[i].preorder[0].sold_quota);
          }
          if (item[i].attributes.size) {
            if (readyStock) {
              item[i].attributes.size.active = true;
            } else {
              item[i].attributes.size.active = false;
            }
            item[i].attributes.size.combination_id = item[i]._id;
            item[i].attributes.size.is_pre_order = item[i].is_pre_order || false;
            if (!/^(.*)(Freebies)(.*)$/.test(item[i].attributes.size.name)) {
              this.listSize.push(item[i].attributes.size);
            }
          }
          if (item[i].attributes.variant) {
            if (readyStock) {
              item[i].attributes.variant.active = true;
            } else {
              item[i].attributes.variant.active = false;
            }
            item[i].attributes.variant.combination_id = item[i]._id;
            item[i].attributes.variant.is_pre_order = item[i].is_pre_order || false;
            item[i].attributes.variant.is_active_in_review = item[i].is_active_in_review;
            if (!/^(.*)(Freebies)(.*)$/.test(item[i].attributes.variant.name)) {
              this.listVariant.push(item[i].attributes.variant);
            }
          }
          if (item[i].attributes.shade) {
            if (readyStock) {
              item[i].attributes.shade.active = true;
            } else {
              item[i].attributes.shade.active = false;
            }
            item[i].attributes.shade.combination_id = item[i]._id;
            item[i].attributes.shade.is_pre_order = item[i].is_pre_order || false;
            if (!/^(.*)(Freebies)(.*)$/.test(item[i].attributes.shade.name)) {
              this.listShade.push(item[i].attributes.shade);
            }
          }
        }

        this.processDuplicate();
      } catch (e) {}
    },
    getGroupType(product) {
      if (product && product.combinations) {
        const result = [];
        const get_combination = product.combinations;

        for (let i = 0; i < get_combination.length; i++) {
          if (get_combination[i].attributes) {
            if (Object.getOwnPropertyNames(get_combination[i].attributes)) {
              const group = Object.getOwnPropertyNames(get_combination[i].attributes);
              for (let j = 0; j < group.length; j++) {
                if (group[j] != '__ob__' && result.indexOf(group[j]) == -1) {
                  result.push(group[j]);
                }
              }
            }
          }
        }

        return result;
      }
    },
    setAllAttribute(combinations, products = '') {
      let wasChange = false;
      if (combinations.attributes && combinations.attributes.size && !wasChange) {
        this.setProductAttribute(combinations.attributes.size, 'size', products);
        wasChange = true;
      }
      if (combinations.attributes && combinations.attributes.variant && !wasChange) {
        this.setProductAttribute(combinations.attributes.variant, 'variant', products);
        wasChange = true;
      }
      if (combinations.attributes && combinations.attributes.shade && !wasChange) {
        this.setProductAttribute(combinations.attributes.shade, 'shade', products);
        wasChange = true;
      }
      if (combinations.attributes && combinations.attributes.non_specify && !wasChange) {
        this.setProductAttribute(combinations.attributes.non_specify, 'non_specify', products);
        wasChange = true;
      }
    },
    setProductAttribute(item, combination, dataProduct = '', condition = '') {
      if (this.productDetails || dataProduct) {
        const grouping_same = [];
        const grouping_not_same = [];
        const grouping_id_same = [];
        let fix_not_same = [];
        let group_name = [];
        let my_combination = {};
        let same = '';
        let not_same = '';
        const get_combination =
          this.productDetails.combinations || [this.productDetails.default_combination] || dataProduct;
        let data_combination = [];
        this.attributeChange = true;
        this.couplesAttributes = Object.assign({}, { ...this.couplesAttributes, [combination]: item.id });
        //this.couplesAttributes[combination] = item.id
        data_combination = get_combination.filter((value) => {
          if (value.attributes[combination]) {
            return value.attributes[combination].id == item.id;
          }
        });

        if (data_combination.length) {
          for (let i = 0; i < data_combination.length; i++) {
            if (Object.keys(data_combination[i].attributes)) {
              group_name = Object.keys(data_combination[i].attributes);
            }
          }
        } else {
          group_name.push('non_specify');
        }

        if (group_name.length) {
          for (let j = 0; j < group_name.length; j++) {
            if (group_name[j] != '__ob__') {
              if (group_name[j] == combination) {
                for (let i = 0; i < get_combination.length; i++) {
                  same = group_name[j];
                  const attr = get_combination[i].attributes[same];
                  if (attr) {
                    if (!get_combination[i].is_out_of_stock_sociolla && get_combination[i].stock > 0) {
                      attr.active = true;
                    }
                    grouping_same.push(attr);
                  }
                }
              }
              if (group_name[j] != combination) {
                for (let i = 0; i < get_combination.length; i++) {
                  not_same = group_name[j];
                  const attr = get_combination[i].attributes[not_same];
                  const attr_same = get_combination[i].attributes[combination];
                  if (attr) {
                    if (!get_combination[i].is_out_of_stock_sociolla && get_combination[i].stock > 0) {
                      attr.active = true;
                    }
                    const idx = grouping_id_same.indexOf(attr.id);
                    if (idx > -1 && attr_same.id == item.id) {
                      grouping_not_same[idx] = attr;
                    } else {
                      grouping_not_same.push(attr);
                    }
                    grouping_id_same.push(attr.id);
                  }
                }
              }
            }
          }
        }

        fix_not_same = grouping_not_same.reduce((unique, o) => {
          if (!unique.some((obj) => obj.id === o.id)) {
            unique.push(o);
          }
          return unique;
        }, []);

        if (not_same && not_same != 'non_specify') {
          if (not_same == 'shade') {
            this.listShade.splice(0);
            this.listShade.push(...fix_not_same);
          } else if (not_same == 'variant') {
            this.listVariant.splice(0);
            this.listVariant.push(...fix_not_same);
          } else {
            this.listSize.splice(0);
            this.listSize.push(...fix_not_same);
          }
        }
        if (group_name.length > 1) {
          const group_not_same = group_name.filter((value) => {
            return value != combination;
          });
          if (group_not_same.length) {
            const filtered = get_combination.filter(
              (x) => x.attributes[combination].id == this.couplesAttributes[combination]
            );
            my_combination = filtered.find((value) => {
              if (value.attributes[group_name[0]].id == this.couplesAttributes[group_name[0]]) {
                return true;
              }
              if (value.attributes[group_not_same[0]].id == this.couplesAttributes[group_not_same[0]]) {
                return true;
              }
            });
            if (!my_combination) {
              my_combination = filtered[0];
            }
          } else {
            my_combination = get_combination.find((value) => {
              return value.attributes[combination].id == this.couplesAttributes[combination];
            });
          }
        } else {
          my_combination = get_combination.find((value) => {
            return (
              value.attributes[combination] && value.attributes[combination].id == this.couplesAttributes[combination]
            );
          });
        }
        const comb = my_combination && Object.keys(my_combination).length ? my_combination : get_combination[0];
        this.activeCombination = comb;
        this.handleProductChanged(this.couplesAttributes, comb, group_name);
        this.attributeChaged = true;
        if (condition === 'second') {
          this.firstInit = false;
        }
      }
    },
    checkStoreActive(storesData) {
      let result = false;
      if (storesData.length > 0) {
        const countStock = storesData.findIndex((res) => res.stock > 0);
        if (countStock > -1) {
          result = false;
        } else {
          result = true;
        }
      } else {
        result = false;
      }
      return result;
    },
    getDiscountType(combination) {
      if (combination && combination.deduction_type) {
        this.isDiscountType = combination.deduction_type;
        if (this.isDiscountType == 'percentage') {
          this.discountValue = combination.deduction_percentage;
        } else {
          this.discountValue = combination.deduction_amount;
        }
      } else {
        this.isDiscountType = '';
        this.discountValue = '';
      }
    },
    handleProductChanged(couples, my_combination, group_name, byRoute = false) {
      if (this.productDetails) {
        let price_combination = '';
        let discount_combination = '';
        let discount_type_combination = '';
        let discount_value_combination = '';
        let images = [];
        const result = [];

        price_combination = my_combination.price;
        if (my_combination.deduction_type) {
          discount_type_combination = my_combination.deduction_type;
          if (discount_type_combination == 'percentage') {
            discount_value_combination = my_combination.deduction_percentage;
          } else {
            discount_value_combination = my_combination.deduction_amount;
          }
        }
        discount_combination = my_combination.price_after_discount;

        images = my_combination.images;
        if (images && images.length > 0) {
          for (let i = 0; i < images.length; i++) {
            result.push(images[i]);
          }
        }

        this.isDiscountType = discount_type_combination;
        this.discountValue = discount_value_combination;

        this.defaultPriceChanged = price_combination;
        if (discount_combination) {
          this.defaultPriceDiscountChanged = discount_combination;
        } else {
          this.defaultPriceDiscountChanged = '';
        }

        if (result && result.length > 0) {
          const image_cover = result.find((value) => {
            return value.is_cover;
          });
          if (image_cover && Object.keys(image_cover).length) {
            this.defaultImagesChanged = image_cover.url;
          } else {
            this.defaultImagesChanged = result[result.length - 1].url;
          }
        } else {
          this.defaultImagesChanged = this.productDetails.product_images.find((x) => x.is_cover).url || '';
        }
        const img = this.productDetails.product_images.filter((x) => x.url === this.defaultImagesChanged);
        if (img && img.length) {
          this.imageDetail = img[0];
        }
      }
    },
    seeStore() {
      if (Object.keys(this.activeCombination).length) {
        const storeId = this.activeCombination.stores.map((x) => {
          if (x.stock && x.stock > 0) {
            return x.id;
          }
        });
        this.$store.commit('setModalStore', { show: true, data: storeId });
      }
    },
    closeSeeMorePopup() {
      this.$store.commit('review/SET_SEE_MOTE_RELEVANT_REVIEWS', {
        isOpen: false,
      });
    },
    scrollToReview() {
      window.scrollTo(0, document.body.scrollHeight);
    },
    onSetLike(review) {
      const key = this.relevantReviews.findIndex((res) => res._id === review.reviewId);
      if (key > -1) {
        this.$set(this.relevantReviews[key], 'has_liked', review.value);
      }
    },
    checkAllCombinationReviewed() {
      if (this.listCombination.length > 0) {
        return this.listCombination.every((p) => p.is_reviewed === true);
      }
      return false;
    },
  },
};
</script>
